import Api from '../../path';
import { fetchData } from '@umu/umu-fetch';
import { IDepartmentInfo } from '@umu/umu-types';

export interface IGetDepartmentsByUmuid {
    umu_id?: string;
}
export const enum DEPATMENT_ROLE {
    BELONGING = '1', // 所属部门
    MANAGE = '2', // 负责的部门
    UNKNOWN = '3', // 既是所属部门也是负责的部门
}
export interface IDepartmentsByUmuid {
    department_id: string;
    department_name: string;
    role: DEPATMENT_ROLE;
    path: IDepartmentInfo[];
}
export const getDepartmentsByUmuid = (data: IGetDepartmentsByUmuid): Promise<IDepartmentsByUmuid[]> => {
    return fetchData(Api.GET_DEPARTMENTS_BY_UMUID, data).then((res: IResponse<IDepartmentsByUmuid[]>) => {
        return res.data;
    });
};
